import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MarkdownPage from './MarkdownPage';


function MarkdownArticle() {
  const { fileName } = useParams();
  const [articleData, setArticleData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/articles/articles.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch articles metadata: ${response.statusText}`);
        }
        return response.json();
      })
      .then((articles) => {
        const article = articles.find((a) => a.fileName === fileName);
        if (article) {
          setArticleData(article);
          setError(null);
        } else {
          setError('Article not found');
        }
      })
      .catch((err) => setError(err.message));
  }, [fileName]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!articleData) {
    return <div>Loading article...</div>;
  }

  return (
    <MarkdownPage 
      fileName={`${fileName}.md`} 
      title={articleData.title} 
      date={articleData.date} 
      imageUrl={articleData.image} 
      tags={articleData.tags}
    />
  );
}

export default MarkdownArticle;
